import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="border-t border-[color:var(--border)] py-8 px-6 text-center text-xs text-[color:var(--text-secondary)]">
      <p className="tracking-[0.2em] mb-3">FAANUU — FAIT AVEC 🌺 POUR LA POLYNÉSIE</p>
      <nav className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
        <Link to="/politique-confidentialite" className="hover:text-[color:var(--primary)] transition">
          Politique de confidentialité
        </Link>
        <span className="text-[color:var(--border)]">·</span>
        <Link to="/suppression-donnees" className="hover:text-[color:var(--primary)] transition">
          Suppression des données
        </Link>
        <span className="text-[color:var(--border)]">·</span>
        <Link to="/rules" className="hover:text-[color:var(--primary)] transition">
          Règles du jeu
        </Link>
      </nav>
    </footer>
  );
}
